import { css } from '@emotion/react'
import { MyTheme, theme } from '@ui/styles/theme'
import ButtonLink from '@ui/atoms/ButtionLink'
import Title from '@ui/atoms/Title'
import { StaticImage } from 'gatsby-plugin-image'

const Recruit = () => {
  const styles = createStyles(theme)

  return (
    <div css={styles.container}>
      <Title title="採用情報" />
      <div css={styles.subTitle}>Recruit</div>
      <div css={styles.inner}>
        <div css={styles.content}>
          <p css={styles.text}>
            世界中のノンデスクワーク業界の仕組みを共に変えていく仲間を募集しています。
          </p>
          <ButtonLink path="/recruit/" text="採用情報へ" />
        </div>
        <div css={styles.image}>
          <StaticImage
            src="../../../images/recruit.webp"
            width={640}
            height={339}
            quality={100}
            alt="採用"
          />
        </div>
      </div>
    </div>
  )
}

const createStyles = (theme: MyTheme) => {
  return {
    container: css`
      position: relative;
      ${theme.mq.isTablet} {
        width: 100%;
      }
    `,
    subTitle: css`
      margin-top: 12px;
      font-size: 14px;
      font-family: Montserrat;
      color: #007b69;
    `,
    inner: css`
      display: flex;
      padding-top: 32px;
      flex-direction: column-reverse;
      ${theme.mq.isTablet} {
        padding-top: 0;
        flex-direction: column;
      }
      ${theme.mq.isDesktop} {
        flex-direction: row;
        justify-content: end;
      }
    `,
    content: css`
      ${theme.mq.isTablet} {
        z-index: 1;
      }
      ${theme.mq.isDesktop} {
        width: 288px;
        margin-right: 32px;
      }
    `,
    text: css`
      margin: 32px 0;
      font-size: 14px;
      line-height: 28px;
    `,
    image: css`
      ${theme.mq.isTablet} {
        position: absolute;
        top: 150px;
        right: 0;
        width: 640px;
      }
      ${theme.mq.isDesktop} {
        position: initial;
        margin-top: -72px;
      }
    `
  }
}

export default Recruit
